// @flow
import * as React from 'react';
import SearchView from 'containers/search';
import { ReviewFieldsets } from 'containers/search/SearchForm';

const label = 'Native Reviews';
const ReviewSearch = (props: *) => (
  <SearchView
    label={label}
    primaryFieldsets={ReviewFieldsets.primaryFieldsets}
    extraFieldsets={ReviewFieldsets.extraFieldsets}
    {...props}
  />
);

ReviewSearch.label = label;

export default ReviewSearch;



// WEBPACK FOOTER //
// ./src/containers/search/NativeReviews.js